import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/image/logo-cn.svg'


const _hoisted_1 = { class: "homepage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_3 = { class: "homepage-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("貓食量計算機 ")
const _hoisted_5 = { class: "m-flex" }
const _hoisted_6 = { class: "m-form-item m-mr-16" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "貓咪體重 (kg)", -1)
const _hoisted_8 = { class: "m-form-item-content" }
const _hoisted_9 = { class: "m-form-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "RER", -1)
const _hoisted_11 = { class: "m-form-item-content" }
const _hoisted_12 = { class: "kcal-result" }
const _hoisted_13 = { class: "m-flex" }
const _hoisted_14 = { class: "m-form-item m-mr-16" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "DER (影響因子)", -1)
const _hoisted_16 = { class: "m-form-item-content" }
const _hoisted_17 = { class: "m-form-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "m-form-item-label" }, "一日所需熱量", -1)
const _hoisted_19 = { class: "m-form-item-content" }
const _hoisted_20 = { class: "kcal-result" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "~", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("0 kcal")
const _hoisted_27 = { class: "m-feed-compute m-feed-compute--center" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 已達新增上限 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 新增貓飼料 ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("a", {
  class: "freepik",
  href: "https://www.freepik.com/vectors/background"
}, "Background vector created by pikisuperstar - www.freepik.com", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", null, "名詞解釋", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "RER (Resting Energy Requirement) 基礎熱量需求", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("RER ＝70 x 體重(kg)"),
  /*#__PURE__*/_createElementVNode("sup", null, "0.75")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, "DER (Day Energy Requirement) 每日熱量需求", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("* 此工具將計算出貓咪一日所需熱量建議值。")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("若您的貓咪有肥胖、過瘦或體重異常的問題，")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("請務必聽從醫師建議，並以醫師處方為主")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", null, "卡洛里計算公式", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, "RER x DER = 一日所需 kcal", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h2", null, "每日熱量需求因素表", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h3", null, "參考", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://reurl.cc/pW8GvZ" }, "教你如何計算貓咪熱量需求")
  ])
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://reurl.cc/Y9mxq0" }, "貓一日所需熱量怎麼算?算式與舉例讓您輕鬆學會！")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_info_circle_filled = _resolveComponent("info-circle-filled")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_m_feed_compute = _resolveComponent("m-feed-compute")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_content, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", null, [
                        _hoisted_4,
                        _createVNode(_component_info_circle_filled, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalVisible = true))
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    lg: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_a_input_number, {
                              value: _ctx.weight,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.weight) = $event)),
                              size: "large",
                              placeholder: "輸入貓咪體重 (kg)",
                              onFocus: _ctx.handleFocus,
                              type: 'number',
                              min: 0,
                              max: 1000
                            }, null, 8, ["value", "onFocus"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.RER) + " kcal ", 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    lg: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_select, {
                              ref: "der",
                              value: _ctx.derActivekey,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.derActivekey) = $event)),
                              size: "large",
                              placeholder: "選擇貓咪類型",
                              onChange: _ctx.handleDerChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.derOptions, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    value: item.value,
                                    key: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              (_ctx.result?.[0])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.result[0]), 1))
                                : _createCommentVNode("", true),
                              (_ctx.result?.[1])
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_22,
                                    (_ctx.result[1] === '*')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, " 更多 "))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.result[1]), 1))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (_ctx.result?.[0])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "kcal"))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _hoisted_26
                                  ], 64))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedCompute, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item.visable)
                        ? (_openBlock(), _createBlock(_component_m_feed_compute, {
                            key: 0,
                            result: _ctx.result,
                            onClose: ($event: any) => (_ctx.handleComputeClose(item))
                          }, null, 8, ["result", "onClose"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  _createVNode(_component_a_col, {
                    class: "m-mb-16",
                    span: 24,
                    lg: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          ghost: "",
                          class: "m-w-240",
                          size: "large",
                          disabled: _ctx.disabledAdd,
                          onClick: _ctx.handleAdd
                        }, {
                          default: _withCtx(() => [
                            (_ctx.disabledAdd)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_28
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_plus_outlined),
                                  _hoisted_29
                                ], 64))
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_30
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.modalVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalVisible) = $event)),
      title: "詳細介紹",
      footer: null
    }, {
      default: _withCtx(() => [
        _hoisted_31,
        _hoisted_32,
        _hoisted_33,
        _hoisted_34,
        _createVNode(_component_a_typography_text, { type: "warning" }, {
          default: _withCtx(() => [
            _hoisted_35
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_text, { type: "warning" }, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        }),
        _createVNode(_component_a_typography_text, { type: "warning" }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider),
        _hoisted_38,
        _hoisted_39,
        _createVNode(_component_a_divider),
        _hoisted_40,
        _createVNode(_component_a_table, {
          dataSource: _ctx.dataSource,
          columns: _ctx.columns,
          pagination: { hideOnSinglePage: true, defaultPageSize: 15 }
        }, null, 8, ["dataSource", "columns"]),
        _createVNode(_component_a_divider),
        _hoisted_41,
        _hoisted_42,
        _hoisted_43
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}